import { render, staticRenderFns } from "./guides.vue?vue&type=template&id=045c47c8&"
import script from "./guides.vue?vue&type=script&lang=js&"
export * from "./guides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports